import cx from '../../../app/editor/utils/makeCls';

export default function LabelField({className, as = 'label', m = 'mb-1', size = 'm', children, ...rest}) {
    const Tag = as;

    return (
        // @ts-ignore
        <Tag className={cx(className, m, 'block capitalize', size === 's' && 'text-sm')} {...rest}>
            {children}
        </Tag>
    );
}